import React, { useEffect } from 'react';
import Stepper from '../components/Stepper';
import Header from '../components/Header';

const OnboardingScreen = () => {
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            event.preventDefault();
            event.returnValue = ''; // This triggers the confirmation dialog in most browsers
        };

        // Add the event listener when the component mounts
        window.addEventListener('beforeunload', handleBeforeUnload);

        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    return (
        <>
            <Header />
            <Stepper />
        </>
    );
};

export default OnboardingScreen;